var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.5,
    height: 19.493,
    viewBox: "0 0 30.5 19.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".amex{fill:#0071ce;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "amex",
    d: "M46.574,36.97l-1.4-1.508-1.4,1.508h-8.6V29.989H32.386l3.463-7.875H39.2l1.229,2.681V22.113h4.134l.726,2.067.726-2.067H49.2V20.885A1.3,1.3,0,0,0,47.915,19.6H19.985A1.3,1.3,0,0,0,18.7,20.885V37.808a1.3,1.3,0,0,0,1.285,1.285h27.93A1.3,1.3,0,0,0,49.2,37.808V36.97Z",
    transform: "translate(-18.7 -19.6)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.082 3.463)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "amex",
    d: "M64.8,44.444h2.234l-2.9-3.072,2.9-3.072H64.854l-1.788,1.955L61.279,38.3H59.1L62,41.372l-2.9,3.072h2.123l1.788-1.955Z",
    transform: "translate(-51.615 -31.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "amex",
    d: "M51.476,43.047V42.1h3.463V40.7H51.476V39.7h3.519V38.3H49.8v6.144h5.195v-1.4Z",
    transform: "translate(-47.51 -31.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "amex",
    d: "M65.356,31.944h1.62V25.8H64.463l-1.4,3.8-1.341-3.8H59.1v6.144h1.676v-4.3l1.564,4.3h1.452l1.564-4.3Z",
    transform: "translate(-51.615 -25.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "amex",
    d: "M50.5,25.8H48.381L45.7,31.888h1.843l.5-1.229h2.793l.5,1.229h1.9Zm-1.955,3.519.838-2.011.838,2.011Z",
    transform: "translate(-45.7 -25.8)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "amex",
    d: "M70.5,42.176l1.564,1.676V40.5Z",
    transform: "translate(-41.564 -28.826)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/AMEX.a465f03ad57894e4162d8bca2deece4d.svg";
export { ForwardRef as ReactComponent };